import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Tab } from 'semantic-ui-react';

import selectors from '../../selectors';
import version from '../../version';

import styles from './AboutPane.module.scss';

const AboutPane = React.memo(() => {
  const [t] = useTranslation();
  const config = useSelector(selectors.selectConfig);
  const shakkiiVersion = config?.shakkiiVersion || version;

  return (
    <Tab.Pane attached={false} className={styles.wrapper}>
      <div className={styles.logoContainer}>
        <img src="/shaka_round_orange.png" alt="Shakkii" className={styles.logo} />
      </div>

      <div className={styles.content}>
        <p className={styles.description}>
          At Shakkii, we believe dashboards only show data and problems — Shakkii tells you what
          needs to be done. Our mission is to cut your workload by 50%, helping you focus on what
          truly matters.
        </p>
        <div className={styles.version}>
          {t('common.version')} {shakkiiVersion}
        </div>
      </div>
    </Tab.Pane>
  );
});

export default AboutPane;
